"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAppSections = void 0;
var react_1 = require("react");
var application_context_1 = require("../components/context/application-context");
var lodash_1 = require("lodash");
var useAppSections = function () {
  var application = (0, react_1.useContext)(application_context_1.ApplicationContext);
  return (0, react_1.useMemo)(function () {
    if (application && application.appSections) {
      var _a = application.options,
        options = _a === void 0 ? {} : _a,
        appSections = application.appSections;
      var appSectionOrder_1 = options.appSectionOrder || [];
      var sortedAppSections = appSectionOrder_1.length ? (0, lodash_1.sortBy)(appSections, function (section) {
        return appSectionOrder_1.indexOf(section.id);
      }) : (0, lodash_1.values)(appSections);
      return sortedAppSections;
    }
    return [];
  }, [application]);
};
exports.useAppSections = useAppSections;